import React from 'react';

import type { Sale } from '@src/domains/sales';
import { useTranslate } from '@src/core/hooks';
import {
  CartCouponAffectedProducts,
  CartSummaryTotal,
  SummaryHeaderCard,
  SummaryHeaderProductCount,
  SummaryHeaderTitle,
  SummaryHeaderTitleRow,
  SummaryItemsList,
  SummaryRoot,
} from '@src/features/cart';

import { useSaleSummary } from '../hooks/useSaleSummary';

type SaleSummaryProps = {
  sale: Sale;
  showItems?: boolean;
  affectedProductsMaxVisible?: number;
};

export const SaleSummary = (props: SaleSummaryProps) => {
  const { sale, showItems = true, affectedProductsMaxVisible } = props;
  const { i18n } = useTranslate();
  const summary = useSaleSummary(sale);

  return (
    <SummaryRoot data-testid='sale-summary'>
      <SummaryHeaderCard>
        <SummaryHeaderTitleRow>
          <SummaryHeaderTitle>{i18n('checkout_order_summary_title')}</SummaryHeaderTitle>
          <SummaryHeaderProductCount>
            {i18n('checkout_cart_summary_products', { count: summary.productCount })}
          </SummaryHeaderProductCount>
        </SummaryHeaderTitleRow>

        <CartSummaryTotal summary={{ ...summary, canManageCoupon: false }} />

        {summary.showAffectedProducts ? (
          <CartCouponAffectedProducts
            productNames={summary.affectedProductNames}
            maxVisible={affectedProductsMaxVisible}
          />
        ) : null}
      </SummaryHeaderCard>

      {showItems ? <SummaryItemsList items={summary.items} /> : null}
    </SummaryRoot>
  );
};

export default SaleSummary;
